import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import Loading from '../../../../../../components/loading/Loading';
import RuleSummary from './RuleSummary';
import { Actions } from '../../rules/Actions';

interface props {
  item: SmartSendItemApiModel;
  limitToSelection: boolean;
  sections: string[];
}

export default function CommonRuleSummary(props: props) {
  return (
    <RuleSummary
      sections={props.sections}
      limitToSelection={props.limitToSelection}
      item={props.item}
      loader={<Loading />}
      actionGroups={[
        [Actions.Item_Service],
        [Actions.Item_CourierService],
        [Actions.Item_Weight],
        [Actions.Item_TariffCode],
        [Actions.Extra_Sms],
        [Actions.Extra_Signature],
        [Actions.Extra_DeliveryGuarantee],
        [Actions.Extra_PrintInStore],
        [Actions.Extra_Cover, Actions.Extra_ExtendedBaseCover],
        [Actions.Extra_ExtendedBaseCover],
        [Actions.Extra_Cover],
        [Actions.Item_Length, Actions.Item_Height, Actions.Item_Width]
      ]}
    />
  );
}
